import React from 'react';
import { AuthLink, AuthMarketing, ButtonSignUp, LayoutSplit, LoaderDots, Text } from 'components';
import { theme } from 'design';
import { AuthButtonGroup, AuthContainer, AuthContent, AuthContentInner } from './styles';

interface JoinProps {
  handleGoogleLogin: () => void;
  onEmailSignUpClick: () => void;
  loginLink: string;
  authHeader: JSX.Element;
  authTerms: JSX.Element;
  isLoading?: boolean;
}

const Join = ({ handleGoogleLogin, onEmailSignUpClick, loginLink, authHeader, authTerms, isLoading, ...rest }: JoinProps): JSX.Element => (
  <LayoutSplit
    {...rest}
    left={
      isLoading ? (
        <LoaderDots size="large" />
      ) : (
        <AuthContainer>
          <AuthContent>
            <AuthContentInner>
              {authHeader}
              <AuthButtonGroup>
                <ButtonSignUp icon="Google" label="Sign up with Google" onClick={handleGoogleLogin} />
                <ButtonSignUp data-cy="sign-up-with-kickfin-button" icon="LogoMark" iconFill={theme.color.neutral[900]} label="Sign up with Email" onClick={onEmailSignUpClick} />
              </AuthButtonGroup>

              <Text>
                {'Already have an account? '}{' '}
                <AuthLink to={loginLink} data-cy="login-link">
                  Log in.
                </AuthLink>
              </Text>
            </AuthContentInner>
          </AuthContent>
          {authTerms}
        </AuthContainer>
      )
    }
    right={<AuthMarketing />}
  />
);

export default Join;
